import * as Yup from "yup";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const phoneValidation = (phoneField = "phone", countryCodeField = "country_code", required = false) =>
	Yup.mixed().nullable().test("phone-validation", "Invalid phone number", function () {
		const { path, parent, createError } = this;
		const phone = parent[phoneField];
		const countryCode = parent[countryCodeField];

		if (!required && (!phone || !countryCode)) {
			return true;
		}

		// Required check
		if (required && (!phone || !countryCode)) {
			return createError({ path, message: "Phone and country code are required" });
		}

		const fullNumber = `${countryCode}${phone}`.replace(/\s+/g, "");

		const phoneNumber = parsePhoneNumberFromString(fullNumber);

		if (!phoneNumber || !phoneNumber.isValid()) {
			return createError({ path, message: "Invalid phone number" });
		}

		return true;
	});


export const isValidPhone = (phone, countryCode) => {
  const fullNumber = `${countryCode}${phone}`.replace(/\s+/g, "");
  const phoneNumber = parsePhoneNumberFromString(fullNumber);

  if (!phoneNumber || !phoneNumber.isValid()) {
    return false;
  }

  return true;
}